import app from 'app';
import Marionette from 'backbone.marionette';

export default Marionette.ItemView.extend({
  className: 'js-notification-view wt-notification-view',

  ui: {
    resendEmail: '.js-sign-in-view-resend-email',
    emailWasSent: '.js-sign-in-view-email-was-sent',
  },
  events: {
    'click @ui.resendEmail': '_resendEmail',
    'click .notificationViewHide': '_action',
  },
  initialize: function (options) {
    this.experatedDays = options.experatedDays;
    this.isFirstLogin = options.isFirstLogin;

    this.template = app.compileTemplate.$('#' + options.templateId);
    setTimeout(() => {
      this.close();
    }, 15e3);
  },
  serializeData: function () {
    return {
      experatedDays: this.experatedDays,
      isFirstLogin: this.isFirstLogin,
    };
  },

  _resendEmail: function () {
    app.startPageController.resendMail().done(
      function (status) {
        console.log('status', status);
        this.ui.emailWasSent.removeClass('hide');
        this.ui.resendEmail.addClass('hide');
      }.bind(this)
    );
  },

  _action: function () {
    this.close();
  },
});
